var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "translate",
    "data-name": "Translate",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      #translate path {\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.14,19.93c-2.43-.66-5.09-.98-8.14-.98s-5.85.33-8.12.98l-.55-1.92c2.46-.7,5.37-1.06,8.67-1.06s6.06.34,8.66,1.05l-.53,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.09,11.02c-2.23,0-5.54-.19-8.59-1.87l.96-1.75c2.64,1.46,5.62,1.62,7.63,1.62,2.85,0,6.14-.7,7.35-1.56l1.16,1.63c-1.78,1.27-5.62,1.93-8.51,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,25.05c-3.27,0-5.84-4.8-5.84-10.93S10.73,3.2,14,3.2s5.84,4.8,5.84,10.93-2.56,10.93-5.84,10.93ZM14,5.2c-1.81,0-3.84,3.67-3.84,8.93s2.02,8.93,3.84,8.93,3.84-3.67,3.84-8.93-2.02-8.93-3.84-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,25.05c-6.1,0-11.05-4.96-11.05-11.05S7.9,2.95,14,2.95s11.05,4.96,11.05,11.05-4.96,11.05-11.05,11.05ZM14,4.95c-4.99,0-9.05,4.06-9.05,9.05s4.06,9.05,9.05,9.05,9.05-4.06,9.05-9.05-4.06-9.05-9.05-9.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.0ee95b5f70c8a3db56fc599ec3fbfec0.svg";
export { ForwardRef as ReactComponent };